module.exports = __webpack_public_path__ + "img/soundcloud.11554af1.svg";